export default __webpack_public_path__ + "static/media/girl-with-offer@2x.ccf10437.png";